<template>
    <div class="game-info-box game_info_bg" v-if="gameInfo">
        <div class="game-logo">
             <img src="/img/index/SSC.png" alt="时时彩">
        </div>
        <div class="game-name">
            <div>{{gameInfo.gameName}}</div>
            <div>
                5分钟一起 全天288期 <br />
                每天00:00 - 24:00销售
            </div>
            <!-- <div>{{gameInfo.remark}}</div> -->
        </div>
        <div class="vertical-line"></div>
        <div class="game-info">
            <img v-if="isVoice" class="shenyin" src="/img/index/icon_shenyin_kai.png" @click="switchVoice('close')">
            <img v-else-if="!isVoice" class="shenyin" src="/img/index/icon_shenyin_guan.png" @click="switchVoice('open')">
            <div class="issue-info">第 <span class="issue">{{gameInfo.openQihao}}</span> 期开奖号码</div>
            <div class="ball-box">
                <div 
                    v-for="(item, index) in openCode"
                    :key="index"
                    :class="`ball${item}`">
                </div>
            </div>
            <div class="fan">
                <span>{{totalCount}}</span>
                <span>{{totalCount >= 23 ? '大' : '小'}}</span>
                <span>{{totalCount % 2 === 0 ? '双' : '单'}}</span>
            </div>
        </div>
        <div class="vertical-line"></div>
        <div class="time-out-box">
            <div class="issue-box">
                第 <span class="issue">{{gameInfo.nextQihao}}</span> 距封盘时间
                <div class="time-out" v-if="timeOutText !== '00:00:00'">{{timeOutText}}</div>
                <!-- <img style="display: block;margin: 18px auto 0;width: 165px;" v-else src="/img/index/fengpan.gif"> -->
                <div style="margin-top: 15px;" class="fengpan" v-else></div>
            </div>
        </div>
        <div class="vertical-line"></div>
        <div class="time-out-box">
            <div class="issue-box">
                第 <span class="issue">{{gameInfo.nextQihao}}</span> 距开奖时间
                <div class="time-out" v-if="kaiJiangTimeOutText !== '00:00:00'">{{kaiJiangTimeOutText}}</div>
                <!-- <img style="display: block;margin: 18px auto 0;width: 165px;" v-else src="/img/index/kaijiang.gif"> -->
                <div style="margin-top: 15px;" class="kaijiang" v-else></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isVoice: false,
            openCode: [],
            timeOut: 0,
            kaiJiangTimeOut: 0,
            timer: null
        }
    },
    props: [
        "initFinished",
        "gameInfo"
    ],
    mounted(){
        this.initData()
    },
    watch: {
        initFinished(){
            this.initData()
        },
        gameInfo(){
            this.initData()
        }
    },
    computed: {
        totalCount(){
            let count = 0
            if(this.gameInfo){
                this.openCode.forEach(item => {
                    count += (item * 1)
                })
            }
            return count
        },
        timeOutText(){
            let timeStr = '00:00:00'
            if(this.timeOut > 0){
                let seconds = (this.timeOut * 1) % 60
                let minutes = Math.floor((this.timeOut * 1) / 60)
                seconds = seconds == 0 ? '00' : seconds > 9 ? seconds : '0' + seconds
                minutes = minutes == 0 ? '00' : minutes > 9 ? minutes : '0' + minutes
                timeStr = `00:${minutes}:${seconds}`
            }
            return timeStr
        },
        kaiJiangTimeOutText(){
            let timeStr = '00:00:00'
            if(this.kaiJiangTimeOut > 0){
                let seconds = (this.kaiJiangTimeOut * 1) % 60
                let minutes = Math.floor((this.kaiJiangTimeOut * 1) / 60)
                seconds = seconds == 0 ? '00' : seconds > 9 ? seconds : '0' + seconds
                minutes = minutes == 0 ? '00' : minutes > 9 ? minutes : '0' + minutes
                timeStr = `00:${minutes}:${seconds}`
            }
            return timeStr
        }
    },
    methods: {
        initData(){
            this.getGameInfo()
            setTimeout(() => {
                this.isVoice = (sessionStorage.getItem('isplayer') == '1')
            },500)
        },
        getGameInfo(){
            if(this.initFinished){
                this.openCode = this.gameInfo.openCode.split(",")
                this.timeOut = this.gameInfo.closeTime
                this.kaiJiangTimeOut = this.gameInfo.nextTime - this.gameInfo.serverTime

                if(this.gameInfo.nextQihao.substr(this.gameInfo.nextQihao.length -4 ,3) == '001'
                    && this.gameInfo.openQihao.substr(this.gameInfo.openQihao.length -4 ,3) != '288'){
                    setTimeout(() => {
                        this.$emit("updateGameInfo")
                    }, 5000)
                }else if(this.gameInfo.openQihao != (this.gameInfo.nextQihao * 1) - 1) {
                    setTimeout(() => {
                        this.$emit("updateGameInfo")
                    }, 5000)
                }

                // if(this.gameInfo.isClose == 0){
                //     this.timeOut = this.gameInfo.closeTime
                // }else {
                //     this.timeOut = (this.gameInfo.nextTime - this.gameInfo.serverTime)
                // }
                this.countDown()
            }
        },
        async switchVoice(type){
            let isplayer = 0
            let isVoice = false
            if(type == "open"){
                isplayer = 1
                isVoice = true
            }

            let data = {
                access_token: this.$store.state.userInfo.access_token,
                uid: this.$store.state.userInfo.uid,
                isplayer
            }

            let result = await this.$http.postAxiosMethod("/user/audioswitch", data)
            if(result){
                this.isVoice = isVoice
                sessionStorage.setItem("isplayer", isplayer)
            }
        },
        countDown(){
            if(this.timer){
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                if(this.timeOut > 0){
                    this.timeOut -- 
                }else if(this.timeOut == 0){
                    this.timeOut = -1
                }
                if(this.timeOut == 0){
                    this.$emit("fengpan")
                }
                this.kaiJiangTimeOut -- 
                if(this.kaiJiangTimeOut <=0){
                    clearInterval(this.timer)
                    setTimeout(() => {
                        this.$emit("updateGameInfo")
                        this.$emit("kaijiang")
                    }, 500)
                }
            },1000)
        }
    },
    beforeDestroy(){
        clearInterval(this.timer)
    }
}
</script>

<style lang="scss" scoped>
.game-info-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 53px;
    width: 100%;
    height: 90px;
    & > div {
        height: 100%;
        color: #FFF;
    }
    .game-logo {
        flex-shrink: 0;
        margin-right: 4px;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        // background-color: #08A4DB;\
        img {
            display: block;
            width: 100%;
            // height: 100%;
        }
    }
    .game-name {
        margin-right: 35px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        & > div {
            text-align: center;
            &:nth-child(1){
                font-size: 16px;
            }
            &:nth-last-child(1){
                margin-top: 10px;
                transform: scale(0.9);
            }
        }
    }
    .vertical-line {
        width: 1px;
        height: 59px;
        background: #08A4DB;
        border: 1px dashed #FFFFFF;
        opacity: 0.32;
    }
    .game-info {
        position: relative;
        padding: 0 68px;
        text-align: center;
        font-size: 12px;
        .shenyin {
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
        }
        .issue-info {
            margin-top: 10px;
            .issue {
                color: #F8EF00;
            }
        }
        .ball-box {
            margin-top: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            & > div {
                transform: scale(0.8);
                margin-right: 6px;
            }
        }
        .fan {
            margin-top: 5px;
            & > span {
                margin-right: 5px;
                display: inline-block;
                padding: 1px 6px;
                border: 1px solid #FFF;
                border-radius: 4px;
                
            }
        }
    }
    .time-out-box {
        flex-shrink: 0;
        padding: 0 68px;
        text-align: center;
        font-size: 12px;
        .issue-box {
            margin-top: 10px;
            .issue {
                color: #F8EF00;
            }
        }
        .time-out {
            margin-top: 15px;
            font-family: DigifaceWide;
            font-size: 38px;
        }
    }
}
</style>